<template functional>
  <div
    id="header"
    class="sticky top-0 z-10 flex items-center justify-center w-full border-b z-5 h-14 border-dark-200 bg-white-translucent dark:bg-dark-translucent"
  >
    <router-link to="/" class="text-2xl font-heading"
      >{{ props.title }}
    </router-link>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Orienteering Games',
    },
  },
}
</script>
<style>
.h-14 {
  height: 3.5rem;
}
</style>
